import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Bell } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api, fmtDate } from "@/lib/api";
import { toast } from "sonner";

const label = (n) => (n.overdue ? `Scaduta da ${-n.days_left} gg` : n.days_left === 0 ? "Scade oggi" : `Tra ${n.days_left} gg`);

export const NotificationBell = () => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const [alerts, setAlerts] = useState([]);
  const location = useLocation();

  const [tick, setTick] = useState(0);
  useEffect(() => {
    const h = () => setTick((t) => t + 1);
    window.addEventListener("bz:deadlines", h);
    return () => window.removeEventListener("bz:deadlines", h);
  }, []);

  useEffect(() => {
    api.get("/alerts").then(({ data }) => setAlerts(data.filter((a) => !a.read))).catch(() => {});
  }, [location.pathname, tick]);

  useEffect(() => {
    api.get("/notifications").then(({ data }) => {
      setItems(data);
      const key = `bz_notified_${new Date().toDateString()}`;
      if (data.length && !sessionStorage.getItem(key)) {
        sessionStorage.setItem(key, "1");
        toast.warning(`Hai ${data.length} scadenze da tenere d'occhio`, { description: data[0].title });
      }
    }).catch(() => {});
  }, [location.pathname, tick]);

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button className="relative p-2 rounded-full hover:bg-slate-100 transition-colors" data-testid="notifications-bell">
          <Bell className="h-5 w-5" />
          {items.length + alerts.length > 0 && (
            <span className="absolute -top-0.5 -right-0.5 h-5 min-w-5 px-1 rounded-full bg-[#E07A5F] text-white text-[11px] grid place-items-center" data-testid="notifications-count">{items.length + alerts.length}</span>
          )}
        </button>
      </PopoverTrigger>
      <PopoverContent align="end" className="w-80 p-0" onClick={(e) => e.target.closest("a") && setOpen(false)} data-testid="notifications-panel">
        <div className="p-4 border-b font-display font-medium">Promemoria</div>
        <div className="max-h-80 overflow-auto">
          {alerts.map((a) => (
            <Link key={a.alert_id} to="/app/avvisi" className="block px-4 py-3 border-b bg-[#E07A5F]/5 hover:bg-[#E07A5F]/10" data-testid={`notification-alert-${a.alert_id}`}>
              <p className="text-sm font-medium">{a.title}</p>
              <p className="text-xs text-slate-500 line-clamp-1">{a.body}</p>
            </Link>
          ))}
          {items.length === 0 && alerts.length === 0 && <p className="p-4 text-sm text-slate-500">Nessuna scadenza imminente.</p>}
          {items.map((n) => (
            <Link key={n.deadline_id} to="/app/scadenze" className="block px-4 py-3 border-b last:border-0 hover:bg-slate-50" data-testid={`notification-${n.deadline_id}`}>
              <p className="text-sm font-medium">{n.title}</p>
              <p className={`text-xs ${n.overdue ? "text-red-600" : "text-slate-500"}`}>{label(n)} · {fmtDate(n.due_date)}</p>
            </Link>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
};
